module.exports = __webpack_public_path__ + "static/media/logo_icon.843e6aac.svg";